import React from 'react';
import _ from 'lodash';
import { T } from 'shared/helper/translate';
export var parseValidators = function parseValidators(_ref) {
  var validators = _ref.validators;
  if (!validators) {
    return undefined;
  }
  var validatorsWithMessages = {};
  _.each(validators, function (validatorFn, validatorKey) {
    validatorsWithMessages[validatorKey] = function (value) {
      return validatorFn(value) ? true : validatorKey;
    };
  });
  return {
    validate: validatorsWithMessages
  };
};
export var componentFromInput = function componentFromInput(input) {
  return typeof input === 'function' ? input : function () {
    return /*#__PURE__*/React.createElement(T, {
      source: input
    });
  };
};
export var ComponentFromInput = function ComponentFromInput(_ref2) {
  var input = _ref2.input;
  var Component = componentFromInput(input);
  return /*#__PURE__*/React.createElement(Component, null);
};
export var useFormHelpers = function useFormHelpers(methods) {
  return {
    populateFormData: function populateFormData(formValues) {
      return methods.reset(formValues);
    },
    mergeFormData: function mergeFormData(formKeyValuePairs) {
      return _.each(formKeyValuePairs, function (value, key) {
        return methods.setValue(key, value);
      });
    },
    preprocessData: function preprocessData(preprocessFn, callback) {
      var additionalData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return function (data) {
        return callback(preprocessFn(data, additionalData));
      };
    }
  };
};
export var convertTrueFalseStringToBoolean = function convertTrueFalseStringToBoolean(value) {
  switch (value) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return value;
  }
};